import { render } from "./ContentLoaderComponent.vue?vue&type=template&id=1e18af5b"
import script from "./ContentLoaderComponent.vue?vue&type=script&lang=js"
export * from "./ContentLoaderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__